import CopyMultipleModal from './CopyMultipleModal';

export default CopyMultipleModal;
